import { Component, Input, Output, EventEmitter   } from '@angular/core';
import { BookingSummaryResult } from 'models';
import { TextSearchPipe } from "shared/pipes/text-search.pipe";

@Component({
    selector: 'app-booking-search',
    template: require('./booking-search.component.html'),
    styles: [require('./booking-search.component.scss')]
})
export class BookingSearchComponent {

    @Input()
    get bookingSummaryResults(): BookingSummaryResult[] {
        return this.summary;
    }

    set bookingSummaryResults(bookingSummaryResults: BookingSummaryResult[]) {
        this.summary = bookingSummaryResults;
    }

    summary: BookingSummaryResult[];

    @Input() pageSize: number;

    bookingSummaryResultsFiltered: BookingSummaryResult[];
    pagedBookingSummaryResultsFiltered: BookingSummaryResult[];

    @Output() bookingSummaryResultChanged: EventEmitter<BookingSummaryResult[]> = new EventEmitter();

    searchString = "";

    constructor(
        public textSearch: TextSearchPipe
    ) {
    }

    searchSummary(bookings: BookingSummaryResult[], searchString: string) {
        const summary = this.textSearch.transform(bookings, searchString);
        return summary;
    }

    sliceItemsPerPage(bookingSummaryResult: BookingSummaryResult[]): BookingSummaryResult[] {
        return bookingSummaryResult.slice(0, bookingSummaryResult.length);
    }

    searchStringChange() {
        if (this.summary) {
            this.bookingSummaryResultsFiltered = this.searchSummary(this.summary, this.searchString);
            this.pagedBookingSummaryResultsFiltered = this.sliceItemsPerPage(this.bookingSummaryResultsFiltered);
            this.bookingSummaryResultChanged.emit(this.pagedBookingSummaryResultsFiltered);          
        } 
    }
}